import { connect } from 'react-redux';
import ConfirmDeleteModal from './shared/confirm_delete_modal.jsx';

import map from 'lodash/map';
import each from 'lodash/each';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  deleteMenuItem
} from 'zoomforth_codesbane_editor/action_creators/navigation.js';

const mapStateToProps = (state, { menuItemsForSection }) => {
  const menuItemDisplayNames = map(menuItemsForSection, (item)=> {
    return `"${item.title}"`;
  }).join(', ');

  return {
    title: 'Delete menu items pointing to section?',
    body: `The menu items ${menuItemDisplayNames} point to this section. Would you like to delete them too? This cannot be undone.`,
    confirmText: 'Delete Links',
    cancelText: 'Cancel'
  };
};


const mapDispatchToProps = (dispatch, { menuItemsForSection }) => (
  {
    onCancel: ()=> { 
      dispatch(closeModal()); 
    },
    onConfirm: ()=> { 
      each(menuItemsForSection, (menuItem)=> {
        dispatch(deleteMenuItem(menuItem));
      });
      dispatch(closeModal());
    }
  }
);

const ConfirmDeleteMenuItemForSectionModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDeleteModal);

ConfirmDeleteMenuItemForSectionModal.editorModalName = 'ConfirmDeleteMenuItemForSectionModal';

export default ConfirmDeleteMenuItemForSectionModal;
